module.exports = __webpack_public_path__ + "static/media/devops.f9b92a1b.svg";